import * as Tone from 'tone'

const scribble = require('./../scribbleSrc')

// @ts-ignore
global.Tone = Tone

global.Tone.Transport.bpm.value = 120

// @ts-ignore
global.Tone.context.resume().then(() => {
	
	global.Tone.Transport.cancel()
	global.Tone.Transport.stop()
	// global.Tone.Transport.start()
	
})

const createToneInstrument2 = (instrument: any) => new Promise((resolve, reject) => {
	const toneInstrument = instrument.name === 'NoiseSynth'
		? new global.Tone[instrument.name](instrument?.params)
		: instrument.name === 'Player'
			? new global.Tone[instrument.name]({
				...instrument?.params,
				onload: () => {
					// console.log({ PlayerParams: true })
					resolve(toneInstrument)
				}
			}, () => {
				// console.log({ Player: true })
				resolve(toneInstrument)
			})
			: instrument.name === 'Sampler'
				? new global.Tone[instrument.name](instrument?.params, () => resolve(toneInstrument))
				: new global.Tone.PolySynth(
					global.Tone[instrument.name],
					instrument?.params
				)

		if (instrument.name !== 'Player' && instrument.name !== 'Sampler')
			resolve(toneInstrument)

		// toneInstrument.buffer.onload(() => {
		// 	console.log({ toneInstrument, loaded: toneInstrument.loaded })
		// 	resolve(toneInstrument)
		// })


})


const createToneInstrument = (instrument: any) => {

	// console.log({ createToneInstrument: instrument })

	const toneInstrument = instrument.name === 'NoiseSynth'
		? new global.Tone[instrument.name](instrument?.params)
		: instrument.name === 'Player'
			? new global.Tone[instrument.name](instrument?.params)
			: instrument.name === 'Sampler'
				? new global.Tone[instrument.name](instrument?.params)
				: new global.Tone.PolySynth(
					global.Tone[instrument.name],
					instrument?.params
				)
	
	return toneInstrument
}

const getChannelParams = (channel: any, toneInstrument: any) => {
	return {
		idx: channel.idx,
		instrument: toneInstrument,
		clips: channel.clips,
		// clips: clips,
		// synth: 'PolySynth',
		// offlineRendering: channel.offlineRendering,
		// offlineRenderingCallback: () => {
		// 	this.isRendering = false
		// },
		// effects: effects ? effects : [],
	}
}

const corsAnywhereUrl = 'https://limitless-headland-33481.herokuapp.com/'

const fixUrlCors = async (url: string) => {

	console.log('fixUrlCors :', url)
	try {
		await fetch(url)
	}
	catch (e: any) {
		console.log({ fixUrlCors: corsAnywhereUrl + url })
		return corsAnywhereUrl + url
	}

	return url
}

const fixInstrumentUrlCors = async (instrument: any) => {

	if (instrument.name === 'Player' && instrument.params.url) {
		instrument.params.url = await fixUrlCors(instrument.params.url)
		// console.log({ instrument })
	}
	else if (instrument.name === 'Sampler' && instrument.params.baseUrl && instrument.params.baseUrl !== '' && instrument.params.urls !== {}) {// TODO : to test
		instrument.params.baseUrl = await fixUrlCors(instrument.params.baseUrl)
	}

	return instrument
}

const findMaxChannelPatternLength = (channelPatterns: any[]): number =>
	channelPatterns.reduce((max: number, channelPattern: any) =>
		channelPattern.pattern.split(channelPattern.pattern.includes(',') ? ',' : '').length > max ? channelPattern.pattern.split(channelPattern.pattern.includes(',') ? ',' : '').length : max, 0)


const createScribbleUtils = async (channels: any[] = []) => {

	const session = new scribble.Session()

	const toneInstruments: any[] = []

	// TODO : handle params update
	const updateToneInstrument = (toneInstrument: any, i: number) => {
		toneInstruments[i] = toneInstrument
	}

	const createChannel = async (channel: any) => {
		const toneInstrument = createToneInstrument(await fixInstrumentUrlCors(channel.instrument))
	
		// const effects = this.createToneEffects(id, channel)
		// this.updateToneEffectsParams()
		// if (channel.offlineRendering) {
		// 	this.isRendering = true
		// }
	
		const channelParams = getChannelParams(channel, toneInstrument)
	
		// console.log({ channelParams })

		toneInstruments.push(toneInstrument)

		// console.log({ channelParams })
	
		session.createChannel(channelParams)// TODO : fix wrong chord
	}

	let refreshIntervalId: any = undefined
	let timeoutId: any = undefined

	const play = (playPattern: any, onProgress: (bar: number) => void = () => null, onComplete: () => void = () => null) => {

		console.log({ playPattern })
		
		// TODO wait for ToneBuffer to load for tinyDaw to work properly
		// Otherwise samples don't have time to load.

		if (playPattern.channelPatterns.length === 0) return

		// await global.Tone.Buffer.loaded()
		const clipDuration = playPattern.clipDuration || '4:0:0'
		const clipDurationInSeconds: number = Tone.Time(clipDuration).toSeconds()

		setTimeout(() => {

			const fixedPlayPattern = {// Scribbletune not playing first clip of the pattern -> so duplicate that
				...playPattern,
				channelPatterns: playPattern.channelPatterns.map((channelPattern: any) => ({
					...channelPattern,
					pattern: /*channelPattern.pattern[0] + ',' + */channelPattern.pattern
				}))
			}

			// console.log({ ToneBuffer: global.Tone.Buffer, loaded: await global.Tone.Buffer.loaded() })
			// session.play(fixedPlayPattern)
			let bar = 0
			refreshIntervalId = setInterval(() => {
				bar++
				onProgress(bar)
			}, clipDurationInSeconds * 1000)

			/* later */
			timeoutId = setTimeout(() => {
				clearInterval(refreshIntervalId)
				setTimeout(() => onComplete(), clipDurationInSeconds * 1000)
			}, (findMaxChannelPatternLength(playPattern.channelPatterns) - 1) * clipDurationInSeconds * 1000)


			console.log('Session play !', { playPattern, channels })
			session.play(playPattern)
			// new global.Tone.Buffer().on('load', () => session.play(fixedPlayPattern))
			
		}, 3000)// TODO : understand why Buffer.on is undefined

		global.Tone.Transport.start()
	}

	const stop = () => {
		clearInterval(refreshIntervalId)
		clearTimeout(timeoutId)
		global.Tone.Transport.cancel()
		global.Tone.Transport.stop()
	}

	channels.forEach(await createChannel)

	return {
		createChannel,
		updateToneInstrument,
		play,
		stop
	}
}

export default createScribbleUtils
